import { Component, OnInit } from '@angular/core';
import { HelperService } from 'src/app/services/Helper/helper.service';
import { LookupService } from 'src/app/services/Lookup/lookup.service';
import { User } from 'src/app/models/ui/User';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-profile-update',
  templateUrl: './user-profile-update.component.html',
  styleUrls: ['./user-profile-update.component.css']
})
export class UserProfileUpdateComponent implements OnInit {

  constructor(private helper: HelperService, private userService: UserService, private lookup: LookupService) { 
    this.userToUpdate = new User();
    this.newUserDetails = new User();
  }

  isAuthorized: string;

  loadingVisible = false;

  userRegex: any;
  emailRegex: any;
  phoneRegex: any;

  isValid: boolean;

  roles: any[];

  userToUpdate: User;
  newUserDetails: User;

  ngOnInit() {
    this.isAuthorized = localStorage.getItem("isAuthorized");

    this.lookup.getUser().subscribe(data => this.newUserDetails = data);
    this.lookup.getRoles().subscribe(data => this.roles = data);

    if(this.isAuthorized === "true") {
      this.helper.setTitle('Provider - Your Profile');
    }
    else
      location.assign("#/login-form");
  }

  submitChanges(e) {
    this.userToUpdate = this.newUserDetails;
    this.userToUpdate.SessionTokenKey = localStorage.getItem("currentSessionTokenKey");
    alert(this.userToUpdate.SessionTokenKey);
    this.isValid = this.checkFormats(this.userToUpdate);
    if(this.isValid == true) {
      this.loadingVisible = true;
      this.userService.updateUser(this.userToUpdate).subscribe(data => this.displayResult(data));

      document.getElementById("userNameBox").style.backgroundColor = "white";
      document.getElementById("emailBox").style.backgroundColor = "white";
      document.getElementById("phoneNumberBox").style.backgroundColor = "white";
    }
  }

  checkFormats(userInfo) {
    this.userRegex = new RegExp("^[a-zA-Z0-9.]+$");
    this.emailRegex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$");
    this.phoneRegex = new RegExp("^[0-9]{0,12}$");

    if(!userInfo.UserName.match(this.userRegex)) {
      alert("Your username contains invalid characters. Please use only alphanumeric characters and dots.");
      document.getElementById("userNameBox").style.backgroundColor = "crimson";
      if(!userInfo.Email.match(this.emailRegex)) document.getElementById("emailBox").style.backgroundColor = "crimson";
      if(!userInfo.PhoneNumber.match(this.phoneRegex)) document.getElementById("phoneNumberBox").style.backgroundColor = "crimson";
      this.loadingVisible = false;
      return;
    }  
    
    if(!userInfo.Email.match(this.emailRegex)) {
      alert("Your email contains invalid characters.");
      document.getElementById("emailBox").style.backgroundColor = "crimson";
      if(!userInfo.PhoneNumber.match(this.phoneRegex)) document.getElementById("phoneNumberBox").style.backgroundColor = "crimson";
      this.loadingVisible = false;
      return;
    } 

    if(!userInfo.PhoneNumber.match(this.phoneRegex)) {
      alert("Your phone number contains invalid characters. Please follow the correct number format.");
      document.getElementById("phoneNumberBox").style.backgroundColor = "crimson";
      this.loadingVisible = false;
      return;
    }

    return true;
  }

  displayResult(data) {
    this.loadingVisible = false;
    setTimeout(() => {
      location.reload();
    }, 2000);
  }
}